import { generate as generateShortUuid } from 'short-uuid';

const nonceMetaTag = document.querySelector(
    'meta[property="csp-nonce"]',
) as HTMLMetaElement | null;

export const BROWSER_SESSION_ID = generateShortUuid();
export const NONCE = nonceMetaTag?.nonce;
